<section class="fulfillment-enrollment">
  <div id="scroll-restoring-element"></div>
  <app-tabs (tabChangeEmitter)="changeTab($event)"></app-tabs>
  <app-product-list [fulfillmentView]="tabIndex === 1"></app-product-list>
</section>
